import Vue from 'vue'
import Vuex from 'vuex'
import { _config } from "../common/js/constant"
import * as dd from "dingtalk-jsapi"; //钉钉
import { requestLogin, requestPhone, requestUser } from '@/api'
import { getToken, setToken, removeToken, getUser, setUser, removeUser } from '@/utils/auth'
import { Toast } from 'vant';
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        requests: 0, //防止重复请求
        token: '',
        user: getUser(),
        keepAlive: [],
        buttonAuth: [],
        isChange: false,
        upload_qiniu_addr: 'http://img.room1000.com/',
        qiniuUpload: 'https://up.qbox.me/',
        idTypeList: ["身份证", "港澳台通行证", "护照", "其它", "驾照", "社会信用代码"], //证件类型
        destineList: ["下定", "取消下定", "已完成"], //预订单状态
        statusReserveList: ["未下定", "已下定", "部分下定"], //下定状态
        cancelStatusList: ["审核通过", "驳回", "提交"], //取消下定审批状态
        payList: ["未支付", "部分支付", "已支付"], //支付状态
        payTypeList: ["支付宝", "微信", "银行卡（储蓄卡）", "信用卡"],
        contractList: [
            "保存",
            "提交",
            "打回",
            "审核通过",
            "已失效",
            "重签作废",
            "作废",
            "退租中"
        ], //合约状态
        CAStatusList: ["未认证", "认证中", "已认证"], //ca状态
        contractTypeList: ['新签', '续签', '换房', '转租'], //合约类型
        customerList: ["电话咨询", "在线咨询", "预约带看", "完成带看", "取消下定", "下定", "签约成功", "无意向", "待跟进", "退租", "创建用户", "抢单", "转让", "获取客户", "派单", "回访", "接单"], //租客状态 / 操作状态
        contactList: [
            "夫妻",
            "父母",
            "子女",
            "兄弟",
            "姐妹",
            "亲戚",
            "朋友",
            "同事",
            "其它"
        ], //紧急联系人关系
        approvalStatusList: ["已同意", "不同意"], //审批结果
        quitTypeList: [
            "到期退租",
            "租客违约退",
            "正常提前退租",
            "公司违约退",
            "房东违约退",
            "协商违约退",
            "续约退租",
            "换房退租",
            "转租退租"
        ], //退租类型
        returnOrderStatus: [
            "保存",
            "提交",
            "打回",
            "审核通过",
            "作废"
        ], //退租单状态
        towardList: [{
                label: "东",
                value: "E"
            },
            {
                label: "南",
                value: "S"
            },
            {
                label: "西",
                value: "W"
            },
            {
                label: "北",
                value: "N"
            },
        ], //房间朝向
        statusListRoom: [
            "待签约",
            "签约中",
            "待开工",
            "施工中",
            "待保洁",
            "空置",
            "",
            "已入住",
            "退房中",
            "已退房"
        ], //房间状态
        applyTypeList: ["换房", "转租", "续约", "退租"], //申请类型
        applyStatusList: ["待处理", "处理中", "已处理", "撤销"], //申请状态
        settlementStatusList: ["钱包已结算", "退租已结算", "作废"], //结算状态
        pContractList: [
            "保存",
            "提交",
            "打回",
            "审核通过",
            "退房中",
            "已失效",
            "作废"
        ], //收房合约状态
        pReturntList: [
            "保存",
            "提交",
            "打回",
            "审核通过"
        ], //退房单状态
        buildingTypeList: ["栋", "幢", "号", "座"], //楼栋单位
        quitTypeListP: [
            "到期退租",
            "租客违约退",
            "正常提前退租",
            "公司违约退",
            "房东违约退",
            "协商违约退"
        ], //退房类型
        remodelStatusList: ["保存", "提交", "打回", "审核通过"], //装修单状态
        workOrderTypeList: [{ label: "维修工单", value: "WX" }, { label: "投诉工单", value: "TS" }, { label: "保洁工单", value: "BJ" }, { label: "咨询工单", value: "ZX" }, { label: "清洗工单", value: "QX" }, { label: "搬运工单", value: "BY" }],
        workOrderStatusList: ["待指派", "待接单", "待处理", "处理中", "已完成", "已关闭"], //工单状态
        workOrderRoleList: ["管家", "租客", "业主", "其他"],
        workOrderLogList: ["创建工单", "派单", "转单", "接单", "开工", "完成", "关闭", "添加备注"],
        belongTypeList: ["我负责的", "我创建的", "我协同的"],
        createDateSortTypeList: ['创建时间由远到近', '创建时间由近到远'],
    },
    mutations: {
        SET_STATE: (state, { key, value }) => {
            if (state.hasOwnProperty(key)) {
                state[key] = value
            }
        },
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_CHANGE: (state, change) => {
            state.isChange = change
        },
        SET_USER: (state, user) => {
            state.user = user
        },
        SET_KEEP_ALIVE: (state, keepAlive) => {
            state.keepAlive = keepAlive
        },
        SET_BUTTON: (state, buttonAuth) => {
            state.buttonAuth = buttonAuth
        }
    },
    actions: {
        // user login
        getPhone({ commit, dispatch }, userInfo) {
            return new Promise((resolve, reject) => {
                if (dd.env.platform !== "notInDingTalk") {
                    dd.ready(function() {
                        dd.runtime.permission.requestAuthCode({
                            corpId: _config.corpId, // 企业id
                            onSuccess: function(info) {
                                requestPhone({ code: info.code }).then(response => {
                                    let param = { phone: response.data, source: 'crm' }
                                    dispatch('getToken', param).then(res => {
                                        resolve(res.data)
                                    }).catch(err => [
                                        reject(err)
                                    ])
                                }).catch(err => {
                                    // alert(err)
                                    reject(err)
                                })
                            },
                            onFail: function(err) {
                                // alert(JSON.stringify(err))
                                reject(err)
                            }
                        });
                    })
                } else {
                    Toast("请用钉钉浏览器打开")
                }
                // let param = { phone: '15895880160' }
                // dispatch('getToken', param).then(res => {
                //     resolve(res.data)
                // }).catch(err => [
                //     reject(err)
                // ])
            })
        },
        // get token
        getToken({ commit, dispatch }, param) {
            return new Promise((resolve, reject) => {
                console.log(param)
                requestLogin(param).then(response => {
                    commit('SET_TOKEN', response.data)
                    setToken(response.data)
                    dispatch('getUserInfo').then(res => {
                        resolve(response)
                    }).catch(err => [
                        reject(err)
                    ])
                }).catch(err => {
                    reject(err)
                })
            })
        },
        // get user
        getUserInfo({ commit, dispatch }) {
            return new Promise((resolve, reject) => {
                requestUser().then(response => {
                    commit('SET_USER', response.data)
                    setUser(response.data)
                    resolve(response)
                }).catch(err => {
                    reject(err)
                })
            })
        },

        // reset user
        resetAll({ commit, dispatch }, token) {
            return new Promise(resolve => {
                commit('SET_TOKEN', token)
                setToken(token)
                commit('SET_CHANGE', true)
                resolve()
                    // dispatch('getUserInfo').then(res => {
                    //     resolve()
                    // })
            })
        },
    },
    modules: {}
})